const contactElement = () => {
    return `
    <div class="footer__contact">
        <p>Hledáte řešení na míru nebo individuální nabídku?</p>
        <a class="btn btn-white" href="/kontakt/" target="_self">
        <span>Kontaktujte nás</span>
        <i class="icon-arrow-right"></i>
        </a>
    </div>
    `;
};

const paymentCompaniesElement = () => {
    return `
    <div class="footer__payments">
        <img src="https://www.airo.cz/user/documents/upload/others/img-payment-logos.png" alt="Možnosti platby">
    </div>
    `;
};

const nexgenSignature = () => {
    return `
    <span id="nexgenSignature">
    Webdesign by
    <a href="https://www.nexgen.cz/${document.documentElement.lang}" class="title" target="_blank">NexGen Digital Studio</a>
    </span>
    `;
};